import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ef1f048"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-top":"20px"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"14px","color":"#8c8c8c"} }, "个字", -1))
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Option = _resolveComponent("Option")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_ImageConfig = _resolveComponent("ImageConfig")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.item.itemType == 'radio' || _ctx.item.itemType == 'checkbox')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Option, {
            item: _ctx.item,
            optionKey: _ctx.optionKey,
            onDelOption: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delOption')))
          }, null, 8, ["item", "optionKey"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item.itemType == 'text')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_a_form_item, {
            class: "correct",
            label: "字符数量限制",
            name: "charMaxCnt",
            rules: _ctx.charMaxCntRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                style: {"width":"160px"},
                placeholder: "请输入...",
                value: _ctx.item.charMaxCnt,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.charMaxCnt) = $event)),
                valueModifiers: { trim: true },
                maxlength: 3,
                allowClear: "",
                size: "small"
              }, null, 8, ["value"]),
              _hoisted_4
            ]),
            _: 1
          }, 8, ["rules"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item.itemType == 'picture' || _ctx.item.itemType == 'multiplepictures')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_ImageConfig, { item: _ctx.item }, null, 8, ["item"])
        ]))
      : _createCommentVNode("", true)
  ]))
}